import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { queenCreekConfig } from "./data";

export default function QueenCreekPage() {
  return <CityPageTemplate config={queenCreekConfig} />;
}